import React from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Col, FormControl, FormGroup, Glyphicon, Row} from "react-bootstrap"
import {TableHeaderColumn} from "react-bootstrap-table"
import BaseGrid from "../BaseGrid"
import FormButtons from "../form/FormButtons"
import {Date, Enums, Grid} from "../../utils"
import {AnimalKind, DOG_MIX_BREED_ID} from "../../utils/enums";

class Dogs extends BaseGrid {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			action: null,
			actionModalOpen: null,
			actionItems: []
		};

		this.handleActionSelect = this.handleActionSelect.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelectAll = this.handleRowSelectAll.bind(this);

		this.handleActionModalDismiss = this.handleActionModalDismiss.bind(this);

		this.formatBreed = this.formatBreed.bind(this);
	}

	getDefaultFilter() {
		return {
			"statuses": ["ACTIVE"],

			"search": "",
			"orderCol": "name",
			"orderDir": "a",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	handleRowSelect({dogId}, isSelected) {
		const {actionItems} = this.state;
		if (isSelected) {
			this.setState({
				actionItems: [...actionItems, dogId].sort()
			});
		} else {
			this.setState({actionItems: actionItems.filter(it => it !== dogId)});
		}
		return false;
	}

	handleRowSelectAll(isSelected) {
		const {items} = this.props;
		if (!isSelected) {
			this.setState({actionItems: []})
		} else {
			const actionItems = [];
			for (let i = 0; i < items.length; i++) {
				actionItems.push(items[i].dogId)
			}
			this.setState({actionItems: actionItems})
		}
	}

	handleActionSelect(action) {
		this.setState({action: action})
	}

	handleActionSubmit() {
		const {actionItems, action} = this.state;
		if (!actionItems || !actionItems.length || !action || !action.value) {
			return
		}

		this.setState({actionModalOpen: true})
	}

	handleActionModalDismiss() {
		this.setState({actionModalOpen: false})
	}

	renderActionModal() {
		// const {session} = this.props;
		const {actionModalOpen, actionItems} = this.state;
		if (!actionModalOpen) {
			return null
		}
		const {items} = this.props;
		const selected = [];
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				if (actionItems.indexOf(items[i].dogId) >= 0) {
					selected.push(items[i])
				}
			}
		}
	}

	formatStatus(cell, row) {
		switch (cell) {
			case "ACTIVE":
				return <Glyphicon glyph={'ok'} title={'Aktivní'}/>;
			case "DELETED":
				return <Glyphicon glyph={'times'} title={'Neaktivní'}/>;
			default:
				return cell
		}
	}

	formatNumber(cell, row) {
		return (cell ? cell : '') + (row.altDogNumbers ? ' (' + row.altDogNumbers + ')' : '');
	}

	formatName(cell, row) {
		return <Link to={{pathname: "/psi/" + row.dogId}}>{cell + (row.altNames ? ' (' + row.altNames + ')' : '')}</Link>
	}

	formatBreed(cell, row) {
		const {enums} = this.props;
		if (row.animalKind === AnimalKind.OTHER) {
			return row.breedDetail;
		}
		if (row.breedId === DOG_MIX_BREED_ID && row.breedDetail) {
			return row.breedDetail.split(',').map((breedId) => Enums.getEnumTitle(enums, 'breed', breedId)).join(' + ');
		}
		return Enums.getEnumTitle(enums, 'breed', row.breedId);
	}

	formatDesc(cell, row) {
		const r = []
		if (row.sex) {
			r.push(row.sex);
		}
		if (row.birthDate) {
			r.push(('' + row.birthDate).length === 4 ? row.birthDate : Date.format(row.birthDate, "DD.MM.YY"));
		}
		if (row.visualDesc) {
			r.push(row.visualDesc);
		}
		return r.join(', ');
	}

	formatActions(cell, row) {
		return <span>
			<Link to={{pathname: "/psi/" + row.dogId}} className="btn">detail</Link>
			&nbsp;
			<Link to={{pathname: "/psi/" + row.dogId + "/uprava"}} className="btn">upravit</Link>
		</span>
	}

	formatRow(row, index) {
		return (row && row.status === 'DELETED' ? "alert-muted" : null)
	}

	getFilter() {
		const {filter} = this.state;

		const statuses = [
			{value: 'ACTIVE', label: 'Aktivní'},
			{value: 'DELETED', label: 'Neaktivní'}
		];

		return [
			<Row key="1">
				<Col xs={6}>
					<FormGroup>
						<FormControl type="text" value={filter.search} name="search" placeholder="Jméno, číslo" onChange={this.handleInputChange}/>
					</FormGroup>
				</Col>
				<Col xs={6}>
					<Row>
						<Col xs={7}>
							<FormButtons currentValue={filter.statuses} options={statuses} name="statuses" onInputChange={this.handleInputChange}/>
						</Col>
						{Grid.renderFilterButtons(this.onFilterReset, 5)}
					</Row>
				</Col>
			</Row>];
	}

	getCols() {
		return [
			<TableHeaderColumn key="dogId" dataField="dogId" width='5%' dataAlign="center" dataSort={true}>#</TableHeaderColumn>,
			<TableHeaderColumn key="dogNumber" dataField="dogNumber" width='12%' dataAlign="center" dataFormat={this.formatNumber} dataSort={true}>Ev. č.</TableHeaderColumn>,
			<TableHeaderColumn key="name" dataField="name" width='12%' dataAlign="center" dataFormat={this.formatName} dataSort={true}>Jméno</TableHeaderColumn>,
			<TableHeaderColumn key="breedId" dataField="name" width='20%' dataAlign="center" dataFormat={this.formatBreed}>Plemeno</TableHeaderColumn>,
			<TableHeaderColumn key="visualDesc" dataField="visualDesc" width='24%' dataAlign="left" dataFormat={this.formatDesc}>Popis</TableHeaderColumn>,
			<TableHeaderColumn key="chipNumber" dataField="chipNumber" width='12%' dataAlign="center" dataSort={true}>Čip</TableHeaderColumn>,
			<TableHeaderColumn key="status" dataField="status" width='5%' dataAlign="center" dataFormat={this.formatStatus}>Stav</TableHeaderColumn>,
			<TableHeaderColumn key="dogId" dataField="dogId" width='10%' dataAlign="center" dataFormat={this.formatActions}>&nbsp;</TableHeaderColumn>
		]
	}

	render() {
		const {isFetchingItems, items, count, filter} = this.props;

		const actions = null;

		const actionCtx = {
			onActionSelect: this.handleActionSelect,
			onActionSubmit: this.handleActionSubmit,
			value: this.state.action,
			key: 'dogId',
			selectRowProp: {
				mode: 'checkbox',
				clickToSelect: true,
				onSelect: this.handleRowSelect,
				onSelectAll: this.handleRowSelectAll,
				selected: this.state.actionItems,
				bgColor: function (row, isSelect) {
					if (isSelect) {
						return "#fcf8e3"
					}
					return null;
				},
				unselectable: []
			},
			actions: actions
		};

		return <div>{Grid.renderFull(isFetchingItems, items, count,
			Grid.getTableOptions(filter, this.onPageChange, this.onSortChange, this.onFilterChange, this.renderPaginationShowsTotal),
			this.getCols(),
			this.getFilter(),
			this.onFilterChange,
			actionCtx, this.formatRow)}
			{this.renderActionModal()}
		</div>
	}
}


Dogs.propTypes = {
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	onShowModal: PropTypes.func.isRequired,
	onUpdateDogStatus: PropTypes.func,
	onShowMessage: PropTypes.func.isRequired
};

export default withRouter(Dogs)



// WEBPACK FOOTER //
// ./src/components/dog/Dogs.js